<template>
  <div class="exclusiveWelfare" :style="isProgram==0?'background-position:0 40px':''">
    <div class="head" v-if="isProgram==0">
      <img src="../../assets/img/store_nav_icon_back_grey.png" alt @click="gotoIndex"  />
      <div class="turnIofo">
        <span>专属福利</span>
      </div>
    </div>
    <!-- <img src="../../assets/img/specially_invite.png" alt class="invite" :style="isProgram==1?'padding-top:0':''" /> -->

	<div class="box_toget" :style="isProgram==0?'padding-top:430px':''"></div>
    <img src="../../assets/img/toGet.png" v-if="token==0" class="toget " @click="gotoLogin" />
    <div class="toget getCenter" v-else>领取成功！红包已放入您的账户</div>
    <div class="box">
      <div class="p_flex">
		  
        <div
          class="packageList"
          v-for="(item,index) in list"
          :key="index"
          :style="index-1==list.length?'margin-bottom:0':''"
        >
          
          <!-- <div class="line"></div> -->
          <div class="pak_content" :style="token!=0||item.dateState*1==-1?'line-height:25px':'line-height:35px'">
            <span>专属红包</span>
            <span v-if="item.minAmount*1>0">满{{item.minAmount}}元可用</span>
            <span v-else>无门槛红包</span>
            <div class="time" v-if="token!=0">
              <div v-if="item.dateState*1==0">有效期至{{item.useEndTime}}</div>
              <div v-if="item.dateState==1" >今天到期{{item.useEndTime.split(' ')[1]}}</div>
              <div v-if="item.dateState==2">明天到期{{item.useEndTime.split(' ')[1]}}</div>

            </div>
          </div>
          <div style='display:flex;flex-direction:column;align-items: center;width:116px'>
            <div class="price">
              <span>￥</span>
              <span>{{item.value*1}}</span>
            </div>
            <div class="receive notReceive" v-if="token==0">未领取</div>
            <div class="receive past" v-if="item.dateState==-1&&token!=0">已过期</div>
            <div class="receive past" v-if="item.isUsed==1&&token!=0">已使用</div>
            <div class="receive" @click="goUse(item.sellerIndustryId)" v-if="token!=0&&item.dateState!=-1&&item.isUsed==0">
               立即使用
          </div>
        </div>
      </div>
      </div>
    </div>
    
    
    <div class='bottonBtn'>
      <van-button class="btn" @click="gotoIndex"  v-if="token!=0&&flag">到首页逛逛</van-button>
      <img class='bottomImg' src="../../assets/img/activity_rule.png" alt />
    </div>
    </div>
</template>
<script type="text/javascript" src="https://res.wx.qq.com/open/js/jweixin-1.3.2.js"></script>
<script>
import { getNewshare } from "@/api/join";
export default {
  data() {
    return {
      isProgram: 0,  //1时小程序,不为1安卓ios进来
      token: 0,  //是否登录,0无
      list:[] ,//红包列表
      flag :false, //是否显示到首页逛逛
    };
  },
  mounted() {
    
    if(window.location.href.indexOf('isProgram')>0){
      this.isProgram = 1;
    }else{
      this.isProgram = 0
    }
    if(this.$route.query.token==null||this.$route.query.token==undefined){
      this.token=0
          }else{
      let parse = window.location.href
          parse =  parse.split('?')[1]
          parse = parse.split('token=')[1]
          this.token  = parse
          }

    this.getNewshare();
  },
  watch: {
    $route: {
        handler() {
            this.token = this.$route.query.token;  
        },
        deep: true,
    }
  }  ,   
  methods: {
    gotoIndex(){   //去首页
      if (this.isProgram == 1) {
        wx.miniProgram.switchTab({ url:`/pages/bazaarIndex/bazaarIndex`});
      } else {
        let u = navigator.userAgent;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        let isOS = isAndroid ? true : false;
        if (isOS) {
          // Android环境
          window.Android.goAppIndex();
        } else {
          // ios环境
          window.webkit.messageHandlers.goAppIndex.postMessage('');
        }
      }
    },
    goUse(sellerIndustryId) {  //去菜市场行业
      let id = sellerIndustryId+''
      if (this.isProgram == 1) {
        let parse = {
          "link":id,
          "latitude":"-1",          
          "longitude":"-1"
          }
        let obj = JSON.stringify(parse)
        wx.miniProgram.navigateTo({ url:`/pages/secondaryNav/secondaryNav?data=${obj}`});
      } else {
        let u = navigator.userAgent;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        let isOS = isAndroid ? true : false;
        if (isOS) {
          // Android环境
          window.Android.gotoBazaar(id);
        } else {
          // ios环境
          window.webkit.messageHandlers.gotoBazaar.postMessage(id);
        }

        this.getNewshare();
      }
    },
    gotoLogin(){  //APP登录
      if (this.isProgram == 1) {
        wx.miniProgram.navigateTo({ url: "/pages/login/login" });
      } else {
        let u = navigator.userAgent;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        let isOS = isAndroid ? true : false;
        if (isOS) {
          // Android环境
          window.Android.goLogin();
        } else {
          // ios环境
          window.webkit.messageHandlers.goLogin.postMessage('');
        }
      }
    },
    getNewshare() {
      //新人红包
      getNewshare({
        token: this.token
      }).then(res => {
        if (res.appStatus.errorCode == 0) {
          
          let list = res.content.list;
          for(let i=0; i<list.length;i++){
            if(list[i].isUsed==0&&list[i].dateState!=-1){
            this.flag = false
              break
            }else{
            this.flag = true
			}
          }
          if(list.length==0){
          this.$toast('暂无红包');
            this.flag = true
          }else{
            this.list = list
          }
        } else {
          this.$toast(res.appStatus.message);

                
            }
        })
    }
    }
};
</script>

<style lang="scss" scoped>
.exclusiveWelfare {
    text-align: left;
	width: 100vw;
            background: url("../../assets/img/specially_invite.jpeg") 0 0 no-repeat;
            background-size: cover;

    .invite {
        margin-bottom: 17px;
        padding-top: 43px;
    }
    .head {
        display: flex;
        align-items: center;
        padding: 3px 0;
        position: fixed;
        z-index: 10;
        text-align: center;
        background: #fff;
        width: 100%;
        border-bottom: 1px solid rgba(220, 220, 220, 1);
        img {
            width: 36px;
            height: 36px;
            margin-right: 11px;
        }
        .turnIofo {
            flex: 1;
            font-size: 18px;
            padding-right: 30px;
        }
    }
    .box {
        margin: 0 17px;
        max-height: 375px;
        width: 340px;
		overflow-y: scroll;
		background:linear-gradient(top, #ffa85a 0%, #dd2a2d 100%);
		background-color:rgba(9,159,95,1);
		border-radius:10px;
    }
    .p_flex {
        display: flex;
        flex-direction: column;
		align-items: center;
		padding-top:13px;
        .packageList {
            background: url("../../assets/img/welfare_background.png") 0 0 no-repeat;
            width: 317px;
            background-size: 100%;
            box-sizing: border-box;
            margin-bottom: 10px;
            height: 98px;
            display: flex;
            align-items: center;
                justify-content: space-between;
            .price {
                width: 98px;
                font-size: 44px;
                color: #DA3F20;
                display: flex;
                align-items: baseline;
                justify-content: center;
                line-height:15px;
                    font-weight: 600;

                span:nth-child(1) {
                    font-size: 21px;
                }
            }
            .line {
                width: 2px;
                height: 57px;
                background: #fff;
                opacity: 1;
                border-radius: 1px;
                margin-left: 11px;
            }
            .pak_content {
                  line-height: 37px;
                display: flex;
                flex-direction: column;
                color: #fff;
                padding: 0 0 0 31px;
                .time{
                  font-size:12px;
                }
                span:nth-child(1) {
                    font-size: 21px;
                    font-weight:800;
                }
                span:nth-child(2) {
                    font-size: 14px;
                }
            }
            .receive {
                color:#fff;
                flex: 1;
                text-align: center;
                font-size:14px;
                font-weight: 800;
                border-radius:25px;
                background: #DA3F20;
                width:74px;
                height:21px;
                line-height: 21px;
                margin-top: 12px;
            }
            .notReceive{
              color:rgba(218,63,32,1);
              background: #fff;
            }
            .noReceive {
                display: flex;
                flex-direction: column;
                align-items: center;
                div:nth-child(2) {
                    text-align: center;
                    font-size: 12px;
                    color: #4d4d4d;
                }
            }

            .past {
				color: #fff;
				background:#ACACAC;
            }
        }
    }
    .toget {
		margin: 0px auto 15px;
		width:340px
	}
	.box_toget{
		padding-top:390px
	}
    .getCenter {
		background: url("../../assets/img/successGreen.png") 0 0 no-repeat;
		
        font-size: 19px;
		color:#fff;
		background-size:cover;
        // border: 1px solid rgba(225, 59, 59, 1);
        width: 330px;
        height: 44px;
		text-align: center;
		font-size:19px;
        line-height: 43px;
        border-radius: 50px;
    }
    img {
        display: flex;
        width: 100vw;
    }
    .bottonBtn {
        display: flex;
        justify-content: center;
        position: relative;

    .btn{
    width:333px;
    height:45px;
    background:linear-gradient(180deg,rgba(255,199,132,1) 0%,rgba(215,32,34,1) 100%);
    border-radius:50px;
    font-size:19px;
    font-weight:bold;
    color:rgba(255,255,255,1);
    position: fixed;
	bottom:15px;
	border: none;

  }
  }
  .bottomImg{
    height:584px;
	margin-top: 30px;
	padding: 0 5px;
    width: 100%;
    box-sizing: border-box;
  }
}
</style>